import React from 'react';
import { useRouteError } from 'react-router-dom';
import Error from 'components/Error';

export default function RootError() {
    const error = useRouteError();

    return (
        <div id="route-error-root" data-testid="route-error-root">
            <Error error={error} />
        </div>
    );
}
